import React from "react";
import "./bottom_bar.scss";

const Bottom_Bar = () => {
  return (
    <div className="bottom-bar-container">
      <a href="https://github.com/RodriOrozco" target="_blank" rel="noreferrer">
        <img
          src={require("../../assets/octocat-github.gif")}
          alt=""
          className="bottom-bar-container__github"
        />
      </a>
      <a
        href="https://www.linkedin.com/in/rodri-orozco/"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src={require("../../assets/linkedin/linkedin-icon.gif")}
          alt=""
          className="bottom-bar-container__linkedin"
        />
      </a>
      <a href="https://t.me/RodriOrozco" target="_blank" rel="noreferrer">
        <img
          src={require("../../assets/telegram/icon-telegram.gif")}
          alt=""
          className="bottom-bar-container__telegram"
        />
      </a>
      <a href="https://wa.me/2646717912" target="_blank" rel="noreferrer">
        <img
          src={require("../../assets/whatsApp/wsp-icon.gif")}
          alt=""
          className="bottom-bar-container__wsp"
        />
      </a>
    </div>
  );
};

export default Bottom_Bar;
